module.exports = __webpack_public_path__ + "static/cuma-rapportcartographique-b08beccaaf0b9f971fe0c2d6481ff3ca.png";